// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon as IconComp} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

// TODO: I don't want the margin here, but for some reason if I make a styled component from this
//       none of its styles actually get applied.
export const Chip = styled.div`
  height: 24px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  background-color: rgba(3, 149, 168, 0.1);
  color: rgb(3, 149, 168);
  padding: 3px 8px;
  font-size: 14px;
  line-height: 18px;
  white-space: nowrap;
  margin: 0px 4px;
`;
Chip.displayName = 'S.Chip';

export const Icon = styled(IconComp)`
  margin-right: 4px;
  width: 14px;
  height: 14px;
`;
Icon.displayName = 'S.Icon';
